<!-- eslint-disable max-len-->
<template>
  <div>
    <!-- Main loop list component-->
    <draggable
      v-model="tempDataWidget"
      :options="{ disabled: modeEdit || modeCreate }"
      style="cursor: grab;"
      @change="changePositionList"
    >
      <div
        v-for="(val, index) in dataWidgetList"
        :key="index"
        :class="{
          'card-attendance' : val.widget_master.name === 'attendance' && !isAttended,
          'card-not-attendance' : val.widget_master.name === 'attendance' && isAttended,
          'card-timesheet' : val.widget_master.name === 'timesheet',
          'card-leave' : val.widget_master.name === 'quota_leave' || val.widget_master.name === 'leave_all_employee',
          'card-mode-edit' : val.widget_master.mode_edit === true}"
        class="widget-box"
      >

        <!-- If mode edit -->
        <b-row
          v-if="val.widget_master.mode_edit === true"
        >
          <b-col md="12">
            <!-- CARD ADD COMPONENT -->
            <j-widget-component-edit
              :data-master="dataMaster"
              :mode-create="modeCreate"
              :mode-edit="modeEdit"
              :data-edit="dataEdit"
              @close-field="closeModeEdit(index)"
            />
          </b-col>
        </b-row>

        <!-- else -->
        <b-row v-else>
          <!-- If Attendance -->
          <b-col
            v-if="val.widget_master.name === 'attendance'"
            class="pl-0 pr-0"
          >
            <j-attendance-widget
              :element="val"
              :data-attendance="dataAttendance"
              :is-attended="isAttended"
            />
          </b-col>

          <!-- If Timesheet -->
          <b-col v-else-if="val.widget_master.name === 'timesheet'">
            <j-timesheet-widget
              :element="val"
              :detail-timesheet="detailTimesheet"
            />
          </b-col>

          <!-- If Discussion -->
          <b-col v-else-if="val.widget_master.name === 'discussion'">
            <j-discussion-widget :element="val"/>
          </b-col>

          <!-- If Channel -->
          <b-col v-else-if="val.widget_master.name === 'channel'">
            <j-discussion-widget :element="val"/>
          </b-col>

          <!-- If HTML -->
          <b-col v-else-if="val.widget_master.name === 'html'">
            <j-html-widget :element="val"/>
          </b-col>

          <!-- If Create Record -->
          <b-col v-else-if="val.widget_master.name === 'create_record'">
            <j-create-record-widget :element="val"/>
          </b-col>

          <!-- If Analytic -->
          <b-col v-else-if="val.widget_master.name === 'analytic_v2'">
            <j-html-widget :element="val"/>
          </b-col>

          <!-- If Quota Leave -->
          <b-col v-else-if="val.widget_master.name === 'quota_leave'">
            <b-row>
              <b-col cols="12">
                <h4>MY LEAVE QUOTA</h4>
              </b-col>
              <b-col
                cols="12"
                style="max-height: 330px; overflow-y: auto;"
              >
                <b-row class="content-quota-leave">
                  <b-col cols="12">
                    <div v-if="list_quota_leave.length === 0">
                      <jLottie
                        :options="defaultOptions"
                        :height="400"
                        :width="420"
                        class="animation"
                        @animCreated="handleAnimation"/>
                    </div>
                    <j-quota-leave-widget
                      v-else
                      :element="val"
                      :quota-leave="list_quota_leave"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <!-- If Leave Employee -->
          <b-col v-else-if="val.widget_master.name === 'leave_all_employee'">
            <j-leave-all-employee-widget :element="val"/>
          </b-col>

          <!-- If Leave Employee -->
          <b-col v-else-if="val.widget_master.name === 'experience_manager'">
            <j-calender-view-widget
              v-if="show_calendar_view"
              :element="val"
              :form-data="calenderViewData.find(c => c.id === val.id).form_data"
              :form-ui="calenderViewData.find(c => c.id === val.id).form_ui"
              :on-widget="true"
            />
          </b-col>

          <!-- If Shortcut Page -->
          <b-col v-else-if="val.widget_master.name === 'shortcut_page'">
            <j-shortcut-page-widget :element="val" />
          </b-col>

          <!-- Else -->
          <b-col
            v-else
            md="6"
          >
            <h4>{{ val.widget_master.name.toUpperCase() }}</h4>
            <label>
              {{ JSON.parse(val.info).name ?
              JSON.parse(val.info).name : val.widget_master.name }}
            </label>
          </b-col>

          <!-- delete -->
          <div class="edit-or-delete">
            <i
              v-if="widgetReadyList.includes(val.widget_master.name) && val.widget_master.name !== 'attendance'"
              class="fa fa-pencil-square-o"
              @click="onClickEdit(index, val.id)"
            />
            <i
              class="fa fa-trash-o"
              @click="onClickDelete(index)"
            />
          </div>
        </b-row>
      </div>
    </draggable>

    <!-- Add component button -->
    <div
      v-if="!modeCreate"
      class="card-field-widget card-add-widget left-add-widget">
      <button
        v-click-outside="hide"
        id="popover-button-event"
        class="btn btn-block btn-add-widget"
        @click="toogle">
        <div class="text-center">
          +
        </div>
      </button>
    </div>

    <!-- CARD ADD COMPONENT -->
    <!-- Dropdown choosing component -->
    <div
      v-show="opened"
      class="card-master-widget-container">
      <div class="card-select-widget">
        SELECT WIDGET
      </div>
      <div
        v-for="(val, index) in dataWidgetMaster"
        :key="index">
        <div
          class="cursor-dropdown"
          @click="chooseMaster(val)">
          {{ val.name.split('_').join(' ').toUpperCase() }}
        </div>
      </div>
    </div>

    <!-- CARD CREATE COMPONENT -->
    <j-widget-component-create
      :data-master="dataMaster"
      :mode-create="modeCreate"
      :mode-edit="modeEdit"
      :data-edit="dataEdit"
      @close-field="closeModeCreate"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-plusplus, no-loop-func */
import { mapState, mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';
import draggable from 'vuedraggable';

import jAttendanceWidget from '@/views/widget/widget-card/jAttendanceWidget';
import jTimesheetWidget from '@/views/widget/widget-card/jTimesheetWidget';
import jDiscussionWidget from '@/views/widget/widget-card/jDiscussionWidget';
import jChannelWidget from '@/views/widget/widget-card/jChannelWidget';
import jHtmlWidget from '@/views/widget/widget-card/jHtmlWidget';
import jCreateRecordWidget from '@/views/widget/widget-card/jCreateRecordWidget';
import jAnalytic2Widget from '@/views/widget/widget-card/jAnalytic2Widget';
import jQuotaLeaveWidget from '@/views/widget/widget-card/jQuotaLeaveWidget';
import jLeaveAllEmployeeWidget from '@/views/widget/widget-card/jLeaveAllEmployeeWidget';
import jCalenderViewWidget from '@/views/widget/widget-card/jCalenderViewWidget';
import jShortcutPageWidget from '@/views/widget/widget-card/jShortcutPageWidget';

import jWidgetComponentCreate from '@/views/widget/jWidgetComponentCreate';
import jWidgetComponentEdit from '@/views/widget/jWidgetComponentEdit';
import jLottie from '../../components/lottie/jLottie';
import * as animationData from '../../assets/notification/loading.json';

export default {
  components: {
    draggable,
    jAttendanceWidget,
    jTimesheetWidget,
    jDiscussionWidget,
    jChannelWidget,
    jHtmlWidget,
    jAnalytic2Widget,
    jCreateRecordWidget,
    jQuotaLeaveWidget,
    jLeaveAllEmployeeWidget,
    jCalenderViewWidget,
    jWidgetComponentCreate,
    jWidgetComponentEdit,
    jShortcutPageWidget,
    jLottie,
  },
  directives: {
    ClickOutside,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    // dataMaster: [Object, null],
    dataWidgetList: {
      type: Array,
      default: () => [],
      required: true,
    },
    position: {
      type: Number,
      default: 0,
      required: true,
    },
  },

  data() {
    return {
      tempDataWidget: [],
      dataWidgetMaster: [],
      modeCreate: false,
      modeEdit: false,
      dataMaster: null,
      dataEdit: null,
      opened: false,
      isAttended: false,
      dataAttendance: null,
      detailTimesheet: {
        finishedTaskCount: 0,
        allTaskCount: 0,
        percentageFinishedTask: 0,
      },
      defaultOptions: { animationData },
      show_calendar_view: false,
      calenderViewData: [],
      widgetReadyList: ['attendance', 'html', 'analytic', 'analytic_v2', 'timesheet',
        'channel', 'discussion', 'create_record', 'todo_task', 'qrcode_scanner',
        'digital_signature_upload', 'digital_signature_sign', 'digital_signature_document',
        'digital_signature_register_peruri', 'quota_leave', 'leave_all_employee',
        'experience_manager', 'embed_url', 'shortcut_page'],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_widget_master', 'list_widget_detail', 'side_menu']),
    ...mapState('jStoreHome', ['timesheet_detail', 'attendance_detail', 'list_quota_leave']),
  },
  watch: {
    list_widget_master(data) {
      this.dataWidgetMaster = data;
    },
    dataWidgetList(data) {
      if (data.find(f => f.widget_master.name === 'attendance')) {
        this.getAttendanceDetail();
      }

      // Filter list widget detail
      const filteredList = data.filter(el =>
        this.widgetReadyList.includes(el.widget_master.name));

      // if have quota leave
      if (filteredList.find(el => el.widget_master.name === 'quota_leave')) {
        const params = {
          pagination: {
            page: 1,
            limit: 50,
            column: 'name',
            ascending: true,
            query: '',
          },
          user_company_id: Number(localStorage.getItem('userCompanyId')),
        };
        this.getQuotaLeave(params);
      }

      // if have experience manager
      const widgetCalendar = filteredList.filter(el => el.widget_master.name === 'experience_manager');

      if (widgetCalendar.length > 0) {
        widgetCalendar.forEach((calender) => {
          this.getDataExperienceManager(calender.info, calender, widgetCalendar.length);
        });
      }

      if (data) this.tempDataWidget = data;
    },
    attendance_detail(val) {
      this.isAttended = val.is_have_attendance;
      this.dataAttendance = val.attendance;
    },
  },
  methods: {
    ...mapActions('jStoreApplication', ['getListWidgetMaster', 'getListComponent', 'getListWidgetDetail', 'deleteWidget', 'actionGetListIcons', 'actionUpdatePage', 'actionGetSideMenuList']),
    ...mapActions('jStoreHome', ['getQuotaLeave', 'getAttendanceDetail']),
    ...mapActions('jStoreApplication', ['updateWidget']),
    ...mapActions('jStoreFormUi', ['actionGetSetupFormUi', 'getFormData']),

    handleAnimation(anim) {
      this.anim = anim;
    },

    getWidgetMaster() {
      const parameter = {
        limit: 0,
        page: 1,
        column: 'id',
        sort: 'asc',
        query: '',
        query_type: '',
      };
      this.getListWidgetMaster({ params: parameter });
    },

    getDataExperienceManager(info, dataWidget, totalData) {
      const req = {
        page: 1,
        limit: 1,
        filter: {
          id: [JSON.parse(info).form_ui_id],
        },
      };
      this.actionGetSetupFormUi(req).then((res) => {
        const response = res.data[0];

        if (response.form_data_id) {
          const reqData = {
            form_data_id: response.form_data_id,
          };
          this.getFormData(reqData).then((param) => {
            this.calenderViewData.push({
              id: dataWidget.id,
              form_data: param.data,
              form_ui: response,
            });

            if (this.calenderViewData.length === totalData) this.show_calendar_view = true;
          });
        }
      });
    },

    generateDataWidgetUpdate(widget, order) {
      const info = JSON.parse(widget.info);
      const widgetType = widget.widget_master.name;

      const data = {
        widget_master_id: widget.widget_master.id,
        position: widget.position,
        order,
      };

      if (widgetType === 'analytic') {
        data.info = JSON.stringify({
          id: info.id,
          name: info.name,
        });
        data.type = 2;
        data.value_id = info.id;
      }
      if (widgetType === 'analytic_v2') {
        data.type = 3;
        data.info = JSON.stringify({
          url: info.url,
          name: info.name,
        });
      }
      if (widgetType === 'attendance') {
        data.type = 1;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
        });
      }
      if (widgetType === 'channel') {
        data.type = 3;
        data.value_id = info.id;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          id: info.id,
          name: info.name.toLowerCase().replace(/\s/g, '-'),
        });
      }
      if (widgetType === 'discussion') {
        data.type_platform = 1;
        data.value_id = `${info.id}`;
        data.pages_id = `${this.$route.params.pageId}`;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          id: info.id,
          name: info.name.toLowerCase().replace(/\s/g, '-'),
        });
      }
      if (widgetType === 'html') {
        data.type = 3;
        data.info = JSON.stringify({
          name: info.name,
          html: info.html,
        });
      }
      if (widgetType === 'timesheet') {
        data.type = 2;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
        });
      }
      if (
        widgetType === 'digital_signature_register_peruri' || widgetType === 'digital_signature_sign' ||
        widgetType === 'digital_signature_document' || widgetType === 'digital_signature_upload'
      ) {
        data.type = 3;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
        });
      }
      if (widgetType === 'create_record') {
        data.type = 1;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          id: info.id,
          name: info.name.toLowerCase().replace(/\s/g, '-'),
          title: info.title,
        });
      }
      if (widgetType === 'todo_task') {
        data.type = 1;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
        });
      }
      if (widgetType === 'quota_leave') {
        data.type = 1;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
        });
      }
      if (widgetType === 'leave_all_employee') {
        data.type = 1;
        data.name = widget.widget_master.name;
        data.info = JSON.stringify({
          name: info.name,
          monitor: info.monitor,
        });
      }

      return data;
    },

    changePositionList() {
      // Update Position if draggable position
      if (this.tempDataWidget.length > 0) {
        this.dataWidgetList.forEach((data, index) => {
          const prevIndex = this.tempDataWidget.findIndex(p => p.id === data.id);

          if (index !== prevIndex) {
            const prevOrder = this.dataWidgetList[prevIndex].order;
            const widgetId = data.id;
            const dataParam = this.generateDataWidgetUpdate(data, prevOrder);
            this.updateWidget({ widgetId, dataParam });
          }
        });
      }
    },

    toogle() {
      this.opened = true;
      this.getWidgetMaster();
    },

    hide() {
      this.opened = false;
    },

    chooseMaster(val) {
      if (this.widgetReadyList.includes(val.name)) {
        this.dataWidgetList.forEach((widget) => {
          // eslint-disable-next-line no-param-reassign
          widget.widget_master.mode_edit = false;
        });
        this.modeCreate = true;
        this.dataEdit = null;
        this.dataMaster = val;
        this.dataMaster.position = this.position;
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Widget Not Ready');
      }
    },

    onClickEdit(index, id) {
      this.dataEdit = this.dataWidgetList[index];
      this.modeEdit = true;
      this.modeCreate = false;

      // Change name to trigger main loop changing html
      this.dataWidgetList.forEach((widget) => {
        // eslint-disable-next-line no-param-reassign
        widget.widget_master.mode_edit = widget.id === id;
      });

      this.dataMaster = {
        id: Number(this.dataEdit.widget_master.id),
        name: this.dataEdit.widget_master.name,
      };
    },

    onClickDelete(index) {
      this.$swal({
        title: '<div style="color:#D2232A">Delete</div>',
        html: `Are you sure to delete <span style="font-family: Poppins-Medium; font-size: 18px;">${this.dataWidgetList[index].widget_master.name}</span>?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          const dataParam = {
            id: this.dataWidgetList[index].id,
            // component_id: this.list_widget_detail[index].id,
          };
          this.deleteWidget(dataParam);
        }
      });
    },

    closeModeCreate() {
      this.modeCreate = false;
      this.dataEdit = null;
    },

    closeModeEdit(index) {
      this.dataEdit = null;
      this.modeEdit = false;
      // Change name to trigger main loop changing html
      this.dataWidgetList[index].widget_master.mode_edit = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/jWidgetList.vue